import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CategoryFilterItem from './CategoryFilterItem';
import { useTaxonomyTreeQuery } from './taxonomyTree.generated';
import { clsx } from 'clsx';
import { Taxonomy } from '@/types';

function findTaxonomyById(tree, id) {
  for (const taxonomy of tree) {
    if (!taxonomy.id) continue;
    if (taxonomy.id === id) {
      return taxonomy;
    }
    if (taxonomy.children && taxonomy.children.length > 0) {
      const childResult = findTaxonomyById(taxonomy.children, id);
      if (childResult) {
        return childResult;
      }
    }
  }
  return null;
}

interface CategoryFIlterProps {
  setSelectedCategoryId: (id: number) => void;
  className?: string;
  category_id?: string | null;
}

const CategoryFilter = (props: CategoryFIlterProps) => {
  const { setSelectedCategoryId, className = '', category_id } = props;
  const { t } = useTranslation();

  const [{ fetching, data }] = useTaxonomyTreeQuery();

  const taxonomy = useMemo(() => {
    if (category_id && data) {
      const result = findTaxonomyById(data.taxonomyTree, parseInt(category_id));
      if (result) return result;
    }
    return null;
  }, [category_id, data]);

  const handleTaxonomySelection = ({ id }: Taxonomy) => {
    setSelectedCategoryId(parseInt(id));
  };

  return (
    <div className={clsx(className, 'w-30-0')}>
      <p className="font-bold text-1-4 mb-4-0">{t('taxonomies.title')}</p>
      {!fetching &&
        data?.taxonomyTree &&
        (data.taxonomyTree.filter((cat) => !!cat?.id) as Taxonomy[]).map(
          (cat) => (
            <CategoryFilterItem
              key={cat.id}
              category={cat}
              activeCategory={taxonomy}
              handleTaxonomySelection={handleTaxonomySelection}
            />
          ),
        )}
    </div>
  );
};

export default CategoryFilter;
